/** @file Document inherit-mode names to compiled InheritMode codes (normal 0 … noScaleOrReflection 4). */
import type { Inherit } from '@pose2d/format/types';
import type { InheritMode } from '../skeletonData';

/**
 * InheritMode code of each document inherit name, in the rig JSON code order of format `prim.inherit`. Core cannot
 * import format at runtime, so this is the one runtime copy; the compiler's COMPILE_CODES.inherit is this table.
 */
export const INHERIT_CODES: Readonly<Record<Inherit, InheritMode>> = Object.freeze({
  normal: 0,
  onlyTranslation: 1,
  noRotationOrReflection: 2,
  noScale: 3,
  noScaleOrReflection: 4,
});
